/*! @azure/msal-common v8.0.0 2022-11-07 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isOpenIdConfigResponse(response) {
    return (response.hasOwnProperty("authorization_endpoint") &&
        response.hasOwnProperty("token_endpoint") &&
        response.hasOwnProperty("issuer") &&
        response.hasOwnProperty("jwks_uri"));
}

export { isOpenIdConfigResponse };
//# sourceMappingURL=OpenIdConfigResponse.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@azure/msal-common/dist/authority/OpenIdConfigResponse.js
// module id = 345
// module chunks = 0